module.exports = __webpack_public_path__ + "static/media/anwalt.03b8c6c5.jpg";